import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';

import SweetAlert from 'react-bootstrap-sweetalert';
import { Badge } from 'reactstrap';
import { Th, Thead, Tr } from 'react-super-responsive-table';

import { getDmxOccupancy, deleteDmxDevice } from '../../store/actions';

class DmxOccupancyList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      showConfirm: false,
      deviceToDelete: null,
      popup: false,
      pop_msg: '',
      alertType: '',
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.loadingDeleteDmxDevice === false && prevProps.loadingDeleteDmxDevice === true) {
      this.props.getDmxOccupancy(this.state.user, this.props.universeId);
      if (this.props.deleteDmxDeviceError) {
        this.setState({
          popup: true,
          pop_msg: this.props.deleteDmxDeviceError.message || 'Error al eliminar el dispositivo',
          alertType: 'error',
        });
      }
    }
  }

  confirmDelete(device) {
    this.setState({ showConfirm: true, deviceToDelete: device });
  }

  doDelete() {
    const { user, deviceToDelete } = this.state;
    this.props.deleteDmxDevice({ id: deviceToDelete.id, token: user.token });
    this.setState({ showConfirm: false });
  }

  confirmPopup() {
    this.setState({ popup: false });
  }

  render() {
    const devices = [...(this.props.devices || [])].sort((a, b) => a.start_channel - b.start_channel);
    return (
      <div className="table-responsive mt-3">
        <table className="table table-centered table-nowrap mb-0">
          <Thead>
            <Tr>
              <Th>{this.props.t('Nombre')}</Th>
              <Th>{this.props.t('Desde')}</Th>
              <Th>{this.props.t('Hasta')}</Th>
              <Th>{this.props.t('Tipo')}</Th>
              <Th>{this.props.t('Elemento')}</Th>
              <Th>{this.props.t('Estado')}</Th>
              <Th>{this.props.t('Actions')}</Th>
            </Tr>
          </Thead>
          <tbody>
            {devices.map((d) => (
              <tr key={d.id}>
                <td>{d.name}</td>
                <td>{d.start_channel}</td>
                <td>{d.start_channel + d.channel_count - 1}</td>
                <td>{d.device_type}</td>
                <td>{d.linked_entity_id}</td>
                <td>
                  <Badge color={Number(d.active) === 1 ? 'success' : 'secondary'} pill>
                    {this.props.t(Number(d.active) === 1 ? 'Activo' : 'Inactivo')}
                  </Badge>
                </td>
                <td>
                  <button
                    className="btn btn-primary waves-effect waves-light buttonStatus txtField"
                    title="Detalle"
                    onClick={() => this.props.history.push({ pathname: `/dmxDeviceDetail/${d.id}`, state: d })}
                  >
                    <i className="mdi mdi-pencil font-size-14 align-middle"></i>
                  </button>
                  <button
                    className="btn btn-danger waves-effect waves-light buttonStatus txtField"
                    title="Eliminar"
                    onClick={() => this.confirmDelete(d)}
                  >
                    <i className="far fa-trash-alt font-size-14 align-middle"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {this.state.showConfirm ? (
          <SweetAlert
            showCancel
            title="¿Estás seguro?"
            cancelBtnBsStyle="danger"
            confirmBtnBsStyle="success"
            confirmBtnText={this.props.t('ok')}
            cancelBtnText={this.props.t('Cancel')}
            onConfirm={() => this.doDelete()}
            onCancel={() => this.setState({ showConfirm: false })}
          >
            {this.props.t('Se eliminará el dispositivo y se apagará su canal')}
          </SweetAlert>
        ) : null}
        {this.state.popup ? (
          <SweetAlert
            type={this.state.alertType === 'correct' ? 'success' : 'error'}
            confirmBtnBsStyle={this.state.alertType === 'correct' ? 'success' : 'danger'}
            title={this.state.pop_msg}
            confirmBtnText={this.props.t('ok')}
            onConfirm={() => this.confirmPopup()}
          ></SweetAlert>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { loadingDeleteDmxDevice, deleteDmxDeviceError } = state.deleteDmxDevice;
  return { loadingDeleteDmxDevice, deleteDmxDeviceError };
};

export default withRouter(
  connect(mapStateToProps, { getDmxOccupancy, deleteDmxDevice })(withNamespaces()(DmxOccupancyList)),
);
